import { motion } from 'framer-motion';

const services = [
  {
    title: 'Hail Damage Repair',
    description: 'Restore your vehicle\'s smooth, flawless finish after a storm. Our experts quickly remove dents and dings caused by hail—no paint, no hassle, just like new again.',
    icon: 'ri-cloud-line',
    image: 'https://static.wixstatic.com/media/35bb17_6ca177db251b4932ba2cd985d0f4be12~mv2.jpg/v1/fill/w_310,h_282,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/pierre-chatel-innocenti-Lk-nu_hX6ms-unsplash%202.jpg',
    turnaround: 'Typical turnaround: 1-3 days',
  },
  {
    title: 'Dent Repair',
    description: 'Got a dent? We\'ll make it disappear. Our professional dent repair restores your vehicle\'s shape and shine without costly paintwork—fast, flawless, and affordable.',
    icon: 'ri-car-line',
    image: 'https://static.wixstatic.com/media/35bb17_f6a5abb7414e4674bc440c4e82ed8265~mv2.jpg/v1/fill/w_310,h_282,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/pierre-chatel-innocenti-Lk-nu_hX6ms-unsplash%202.jpg',
    turnaround: 'Typical turnaround: Same day',
  },
  {
    title: 'Rental Car Repair',
    description: 'Need quick, reliable repairs before returning your rental? We fix dents, scratches, and hail damage fast—helping you avoid costly rental company fees.',
    icon: 'ri-key-line',
    image: 'https://static.wixstatic.com/media/35bb17_93b2fba6386341c8b16db9ec91e37477~mv2.jpg/v1/fill/w_310,h_282,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/pierre-chatel-innocenti-Lk-nu_hX6ms-unsplash%202.jpg',
    turnaround: 'Typical turnaround: 2-4 hours',
  },
  {
    title: 'Fleet Vehicle Repair',
    description: 'Keep your business moving with fast, reliable fleet repairs. We handle dents, hail damage, and bodywork to keep your vehicles looking professional and on the road.',
    icon: 'ri-truck-line',
    image: 'https://static.wixstatic.com/media/35bb17_7446961a5c8b4f6689f1943c658ba4b3~mv2.jpg/v1/fill/w_310,h_282,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/pierre-chatel-innocenti-Lk-nu_hX6ms-unsplash%202.jpg',
    turnaround: 'Volume pricing available',
  },
];

export default function Services() {
  return (
    <section className="py-24 bg-bg-soft">
      <div className="max-w-[1200px] mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="font-montserrat font-bold text-4xl md:text-5xl text-text-dark mb-4">
            Our Services
          </h2>
          <p className="font-inter text-lg text-text-muted max-w-2xl mx-auto">
            Professional paintless dent repair services for all your needs
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 group"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 w-14 h-14 flex items-center justify-center bg-primary rounded-full">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <div className="p-8">
                <h3 className="font-montserrat font-bold text-2xl text-text-dark mb-3">
                  {service.title}
                </h3>
                <p className="font-inter text-base text-text-muted mb-4 leading-relaxed">
                  {service.description}
                </p>
                <span className="font-inter text-sm text-secondary font-medium">
                  {service.turnaround}
                </span>
              </div>
            </motion.div>
          ))}
        </div>

        {/* How It Works */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mt-24"
        >
          <h3 className="font-montserrat font-bold text-3xl text-text-dark text-center mb-12">
            How It Works
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 flex items-center justify-center bg-primary/10 rounded-full mx-auto mb-4">
                <span className="font-montserrat font-bold text-3xl text-primary">1</span>
              </div>
              <h4 className="font-montserrat font-semibold text-xl text-text-dark mb-2">
                Send Photos / Contact Us
              </h4>
              <p className="font-inter text-text-muted">
                Share photos of the damage or give us a call for a quick assessment
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 flex items-center justify-center bg-secondary/10 rounded-full mx-auto mb-4">
                <span className="font-montserrat font-bold text-3xl text-secondary">2</span>
              </div>
              <h4 className="font-montserrat font-semibold text-xl text-text-dark mb-2">
                Get an Estimate + Schedule
              </h4>
              <p className="font-inter text-text-muted">
                Receive a free, honest estimate and book your convenient appointment
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 flex items-center justify-center bg-primary/10 rounded-full mx-auto mb-4">
                <span className="font-montserrat font-bold text-3xl text-primary">3</span>
              </div>
              <h4 className="font-montserrat font-semibold text-xl text-text-dark mb-2">
                Repair Completed
              </h4>
              <p className="font-inter text-text-muted">
                Your vehicle is restored to perfection—like it never happened
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
